// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JiaMengGoods_style_wrapper__3vw1P","list":"JiaMengGoods_style_list__3hvm8","checkAll":"JiaMengGoods_style_checkAll__zqcAV"};